import styled from '@emotion/styled';
import { Breadcrumb, Divider, Image, Space } from 'antd';
import { FaHome } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../routes';
import { ORANGE, YELLOW } from '../../../shared/colors';
import { Footer } from '../../homePage/components/Footer';
import { Layout } from '../../shared/Layout';
import { FiscaBox } from '../components/FiscaBox';

const Container = styled.div`
  // height: calc(100vh - 32px);
  background-color: white;

  .banner {
    height: 300px;
    background-color: white;
    background-image: url('assets/images/fisca.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    > .black-background {
      padding: 5% 15% 5% 15%;
      background-color: rgba(0, 0, 0, 0.6);
      width: 100%;
      height: 100%;
    }

    .bread-crumb {
      font-size: 14px;
      margin-top: 10px;

      span {
        color: white;
        font-family: Poppins-L;
      }
    }

    .menus {
      display: flex;

      > p {
        text-transform: uppercase;
        font-family: Poppins-L;
        font-size: 14px;
        padding: 4.5px 5px;
        margin-right: 0px;
        text-align: center;

        &:hover {
          background-color: ${YELLOW};
          cursor: pointer;
        }
      }
    }
  }

  > .content {
    min-height: 400px;
    background-color: white;
    color: black;
    padding: 2% 15%;

    > h2 {
      font-family: Poppins-B;
      font-size: 25px;
      margin-bottom: 15px;
    }

    > div {
      display: flex;
      flex-wrap: wrap;
      margin-top: 25px;
    }
  }

  .text {
    font-size: 16px;
    color: #424242;
  }
`;

export const FiscaliteComptaPage = () => {
  const history = useHistory();

  return (
    <Layout>
      <Container>
        <div className='banner'>
          <div className='black-background'>
            <Space size={10}>
              <Image
                alt='moranje-logo'
                src='assets/images/moranje-logo.png'
                // height={250}
                width={130}
                preview={false}
                style={{ objectFit: 'contain', cursor: 'pointer' }}
              />
              <div>
                <div
                  style={{
                    fontFamily: 'Poppins-B',
                    fontSize: 35,
                  }}
                >
                  <span style={{ color: ORANGE }}>Moranj</span>
                  <span style={{ color: '#6d4c41' }}>E</span>
                  <span style={{ color: YELLOW }}>trade</span>
                </div>
                <div
                  style={{
                    fontFamily: 'Poppins-B',
                    fontSize: 30,
                  }}
                >
                  Fiscalité & Comptabilité
                </div>
              </div>
            </Space>
            <Breadcrumb separator='>' className='bread-crumb'>
              <Breadcrumb.Item>
                <FaHome style={{ marginRight: 5 }} />
                <span>Accueil</span>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <span>Fiscalité & Comptabilité</span>
              </Breadcrumb.Item>
            </Breadcrumb>
            <Divider style={{ backgroundColor: 'white', marginBottom: 0 }} />

            <div className='menus'>
              {FISCA.map((form, i) => (
                <p key={i} onClick={() => history.push(form.link)}>
                  {form.sumaryLabel}
                </p>
              ))}
            </div>
          </div>
        </div>

        <div className='content'>
          <h2>Fiscalité & Comptabilité</h2>
          <p className='text'>
            In progress...
            <br />
            <br />
            In progress...
          </p>

          <div>
            {FISCA.map((form, i) => (
              <span onClick={() => history.push(form.link)}>
                <FiscaBox key={i} title={form.label} body={form.content} />
              </span>
            ))}
          </div>
        </div>

        <div style={{ backgroundColor: 'white' }}>
          <Footer />
        </div>
      </Container>
    </Layout>
  );
};

const FISCA = [
  {
    label: 'Introduction à la comptabilité financière',
    sumaryLabel: 'Comptabilité financière',
    link: ROUTES.FISCA.COMPTA_FINANCE,
    content: 'In progress...',
  },
  {
    label: 'Comptabilité des obligations',
    sumaryLabel: 'Comptabilité des obligations',
    link: ROUTES.FISCA.COMPTA_OBLIG,
    content: 'In progress...',
  },
  {
    label: 'Fiscalité des obligations',
    sumaryLabel: 'Fiscalité des obligations',
    link: ROUTES.FISCA.FISCALITE_OBLIG,
    content: 'In progress...',
  },
  {
    label: 'Analyse des états financiers',
    sumaryLabel: 'Analyse des états financiers',
    link: ROUTES.FISCA.ANALYSE_ETAT,
    content: 'In progress...',
  },
  {
    label: 'Gestion des risques financiers',
    sumaryLabel: 'Risques financiers',
    link: ROUTES.FISCA.RISQUE_FINANCE,
    content: 'In progress...',
  },
  {
    label: 'Éthique et réglementation',
    sumaryLabel: 'Éthique & réglementation',
    link: ROUTES.FISCA.ETHIQUE_REGL,
    content: 'In progress...',
  },
];
